/* VIDAS landing — interactivity (scroll reveal, gallery morph, sticky CTA,
   FAQ accordion, testimonial tabs). No external dependencies. */
(function () {
  'use strict';

  // The styles snippet is rendered per-section, so this script tag may appear
  // multiple times. Guard so initialization only ever runs once.
  if (window.__vidasLandingInit) return;
  window.__vidasLandingInit = true;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* ---- Scroll reveal ---------------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.vidas-lp .vidas-reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.1 });

    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---- Product gallery: thumbnail switch + morph + lightbox ------------- */
  function initGallery() {
    var gallery = document.querySelector('.vidas-lp [data-vidas-gallery]');
    if (!gallery) return;

    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-vidas-thumb]'));
    var current = gallery.querySelector('[data-vidas-current]');
    var prev = gallery.querySelector('[data-vidas-prev]');
    var lightbox = document.querySelector('.vidas-lp [data-vidas-lightbox]');
    var lightboxImg = lightbox ? lightbox.querySelector('img') : null;
    if (!current || !thumbs.length) return;

    var selected = 0;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function select(i, src, full, alt) {
      if (i === selected) return;
      var oldSrc = current.getAttribute('src');

      // Set previous layer to the outgoing image, then morph it out.
      if (prev && !reduceMotion) {
        prev.setAttribute('src', oldSrc);
        prev.style.opacity = '1';
        prev.style.filter = 'blur(0px)';
        prev.style.transform = 'scale(1)';
        // force reflow so the transition runs
        void prev.offsetWidth;
        prev.style.transition = 'opacity .6s ease, filter .6s ease, transform .6s ease';
        prev.style.opacity = '0';
        prev.style.filter = 'blur(18px)';
        prev.style.transform = 'scale(0.94)';
      }

      // Swap current image and morph it in with a circular reveal.
      current.setAttribute('src', src);
      current.setAttribute('alt', alt || '');
      current.setAttribute('data-full', full || src);

      if (!reduceMotion) {
        current.style.transition = 'none';
        current.style.clipPath = 'circle(0% at 50% 50%)';
        current.style.filter = 'blur(14px)';
        current.style.transform = 'scale(1.08)';
        current.style.opacity = '0';
        void current.offsetWidth;
        current.style.transition = 'clip-path .75s cubic-bezier(0.16,1,0.3,1), filter .75s ease, transform .75s ease, opacity .75s ease';
        current.style.clipPath = 'circle(75% at 50% 50%)';
        current.style.filter = 'blur(0px)';
        current.style.transform = 'scale(1)';
        current.style.opacity = '1';
      }

      thumbs[selected] && thumbs[selected].classList.remove('is-active');
      thumbs[i] && thumbs[i].classList.add('is-active');
      selected = i;
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        select(
          i,
          thumb.getAttribute('data-src'),
          thumb.getAttribute('data-full'),
          thumb.getAttribute('data-alt')
        );
      });
    });

    // Lightbox open/close
    var mainBtn = gallery.querySelector('[data-vidas-zoom]');
    if (mainBtn && lightbox && lightboxImg) {
      mainBtn.addEventListener('click', function () {
        lightboxImg.setAttribute('src', current.getAttribute('data-full') || current.getAttribute('src'));
        lightboxImg.setAttribute('alt', current.getAttribute('alt') || '');
        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
      function close() {
        lightbox.classList.remove('is-open');
        document.body.style.overflow = '';
      }
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target.hasAttribute('data-vidas-lightbox-close')) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    }
  }

  /* ---- Sticky CTA ------------------------------------------------------- */
  function initSticky() {
    var bar = document.querySelector('.vidas-lp .vidas-sticky');
    if (!bar) return;
    function onScroll() {
      if (window.pageYOffset > 600) bar.classList.add('is-visible');
      else bar.classList.remove('is-visible');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- FAQ accordion ---------------------------------------------------- */
  function initFaq() {
    var items = document.querySelectorAll('.vidas-lp .vidas-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var q = item.querySelector('.vidas-faq__q');
      var a = item.querySelector('.vidas-faq__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        // single-collapsible behavior
        items.forEach(function (other) {
          other.classList.remove('is-open');
          var oa = other.querySelector('.vidas-faq__a');
          if (oa) oa.style.maxHeight = null;
        });
        if (!isOpen) {
          item.classList.add('is-open');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  }

  /* ---- Testimonial category tabs --------------------------------------- */
  function initTestimonials() {
    var root = document.querySelector('.vidas-lp [data-vidas-testi]');
    if (!root) return;
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-vidas-pill]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-vidas-panel]'));
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var key = pill.getAttribute('data-vidas-pill');
        pills.forEach(function (p) { p.classList.toggle('is-active', p === pill); });
        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-vidas-panel') === key);
        });
      });
    });
  }

  /* ---- Smooth-scroll anchors to product -------------------------------- */
  function initAnchors() {
    document.querySelectorAll('.vidas-lp [data-vidas-scroll]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var target = document.getElementById('vidas-product');
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  }

  ready(function () {
    initReveal();
    initGallery();
    initSticky();
    initFaq();
    initTestimonials();
    initAnchors();
  });
})();